/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChecklistItem
 */
export interface ChecklistItem {
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    checklistKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChecklistItem
     */
    checked: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    updatedByUser?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ChecklistItem interface.
 */
export function instanceOfChecklistItem(value: object): value is ChecklistItem {
    if (!('checklistKey' in value) || value['checklistKey'] === undefined) return false;
    if (!('checked' in value) || value['checked'] === undefined) return false;
    return true;
}

export function ChecklistItemFromJSON(json: any): ChecklistItem {
    return ChecklistItemFromJSONTyped(json, false);
}

export function ChecklistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistItem {
    if (json == null) {
        return json;
    }
    return {
        
        'checklistKey': json['checklistKey'],
        'checked': json['checked'],
        'updatedByUser': json['updatedByUser'] == null ? undefined : json['updatedByUser'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

  export function ChecklistItemToJSON(json: any): ChecklistItem {
      return ChecklistItemToJSONTyped(json, false);
  }

  export function ChecklistItemToJSONTyped(value?: ChecklistItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checklistKey': value['checklistKey'],
        'checked': value['checked'],
        'updatedByUser': value['updatedByUser'],
        'updatedAt': value['updatedAt'],
    };
}

